webpackJsonp([9],{

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_global_log_engagement__ = __webpack_require__(64);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


var SMART_FILTER_PARAM = 'sf';
var DELIMITER = "-";
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#reset-smart-filters').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter').prop('disabled', false).prop('checked', false);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_global_log_engagement__["a" /* logEngagement */])(window.location.href, 'smart_filters', 'start over');
    submitFilters(true);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#submit-smart-filters').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal-close').trigger('mousedown');
    var ignoreHistory = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('ignoreHistory');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('ignoreHistory', false);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_global_log_engagement__["a" /* logEngagement */])(window.location.href, 'smart_filters', 'apply filters');
    submitFilters(!ignoreHistory);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filters').on('click', function () {
    if (getSmartFilters()) {
      updateValidFilters();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters-form input').on('change', function () {
    updateValidFilters();
    var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'smart_filter', $this.is(':checked') ? 'select' : 'deselect', $this.attr('id'));
  });
  function updateValidFilters() {
    var data = getSmartFilters();
    // data can contain hidden fields, only check if user has selected anything
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter:checked').length) {
      var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#main-content');
      var ajaxUrl = appendQuery(removeURLParameter($container.data('baseUrl'), SMART_FILTER_PARAM), data).replace(/.*\?/, "".concat(window.rcProps.smartFiltersCheckHref, "?"));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(ajaxUrl).done(function (result) {
        var validFilters = Object.keys(result).reduce(function (set, filterType) {
          var filterNames = result[filterType];
          var _iterator = _createForOfIteratorHelper(filterNames),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var filterName = _step.value;
              set.add("sf_".concat(filterType, "_").concat(filterName));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return set;
        }, new Set());
        var selectedCategories = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter:checked').toArray().reduce(function (set, el) {
          set.add(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).attr('name'));
          return set;
        }, new Set());
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter').each(function () {
          var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
          $el.prop('disabled', !($el.is(':checked') || validFilters.has($el.attr('id')) || selectedCategories.has($el.attr('name'))));
        });
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter').each(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('disabled', false);
      });
    }
  }
  function submitFilters(updateHistory) {
    var data = getSmartFilters();
    var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#main-content');
    var filtersToClear = {
      pageNum: true
    };
    filtersToClear[SMART_FILTER_PARAM] = true;
    filtersToClear['sortBy'] = true;
    var windowUrl = appendQuery(clearQueryParameters(window.location.href, filtersToClear), data);
    var baseUrl = $container.data('baseUrl');
    var ajaxUrl = baseUrl.indexOf('?') > 0 ? windowUrl.replace(/.*\?/, "".concat($container.data('baseUrl'), "&")) : windowUrl.replace(/.*\?/, "".concat($container.data('baseUrl'), "?"));
    if (updateHistory) {
      window.history.pushState({}, "", windowUrl);
    } else {
      window.history.replaceState({}, "", windowUrl);
    }
    new ContentUpdate($container, ajaxUrl, false, null, function () {
      var $filterCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-filter-count');
      var count = (Number.parseInt($filterCount) || 0) + __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter:checked').length;
      $filterCount.text(count > 0 ? '(' + count + ')' : '');
      getMultiselectLeftNav();
    }).go();
    if (insertPageTrack && typeof insertPageTrackWithInfo === 'function') {
      insertPageTrackWithInfo(windowUrl, true);
    }
  }
  function getSmartFilters() {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters-form input').toArray().filter(function (filter) {
      return filter.hidden || filter.checked;
    }).map(function (filter) {
      return "".concat(SMART_FILTER_PARAM, "=").concat(filter.dataset.filterType).concat(DELIMITER).concat(filter.value);
    }).join('&');
  }
  window.onpopstate = function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#selected-filters').empty();
    var selectedFilters = new Set();
    var searchParams = new URLSearchParams(location.search);
    searchParams.forEach(function (value, key) {
      if (key === SMART_FILTER_PARAM) {
        selectedFilters.add(value);
      }
    });
    var $filters = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters-form input[type="checkbox"]');
    $filters.prop('disabled', false).prop('checked', false).each(function () {
      var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if (selectedFilters.has("".concat($this.prop('name')).concat(DELIMITER).concat($this.prop('value')))) {
        $this.prop('checked', true);
      }
    });

    // can't just call submit filters because of pill generation in smart-filters.js
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#submit-smart-filters').data('ignoreHistory', true).trigger('click');
    updateValidFilters();
  };
});

/***/ })

},[336]);


// WEBPACK FOOTER //
// dist/search.js